import { render, staticRenderFns } from "./cuccOpen2.vue?vue&type=template&id=843c722c&scoped=true&"
var script = {}
import style0 from "./cuccOpen2.vue?vue&type=style&index=0&id=843c722c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843c722c",
  null
  
)

export default component.exports